import React from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              {companyInfo.name}
              <span className="text-teal-400 text-sm ml-2">LLC</span>
            </h3>
            <p className="text-slate-400 mb-4 max-w-md">
              {companyInfo.description}. Partner with us for strategic IT talent and consulting solutions.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors"
                aria-label="LinkedIn">

                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors"
                aria-label="Twitter">

                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="mailto:contact@prisamtechai.com"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-teal-500 transition-colors"
                aria-label="Email">

                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-teal-400 transition-colors">

                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-teal-400 transition-colors">

                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-teal-400 transition-colors">

                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-teal-400 transition-colors">

                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-slate-400">IT Staffing</li>
              <li className="text-slate-400">IT Consulting</li>
              <li className="text-slate-400">Managed Services</li>
              <li className="text-slate-400">Cloud Solutions</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm mb-4 md:mb-0">
              © {currentYear} {companyInfo.name} LLC. All Rights Reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-slate-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
          <p className="text-slate-500 text-sm text-center md:text-left mt-4">
            Based in {companyInfo.location} | Serving Clients {companyInfo.serviceArea}
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;